"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublicClient = void 0;
const viem_1 = require("viem");
const isWalletClient_1 = require("./isWalletClient");
const getPublicClient = (client) => {
    if ((0, isWalletClient_1.isWalletClient)(client)) {
        return client.extend(viem_1.publicActions);
    }
    return client;
};
exports.getPublicClient = getPublicClient;
